module.exports = __webpack_public_path__ + "img/marker-green.27d6c94f.png";